var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    rx: 15.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#E5E5E5",
    rx: 15.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Instagram_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Instagram_svg__b)",
    d: "M16.006 6.152c-4.113 0-5.315.004-5.55.023-.843.07-1.368.203-1.94.488-.441.219-.789.473-1.132.829q-.937.972-1.141 2.395c-.067.46-.086.555-.09 2.907v3.201c0 4.11.005 5.31.024 5.544.068.821.197 1.338.47 1.903a4.15 4.15 0 0 0 2.69 2.197c.405.105.854.162 1.43.19.243.01 2.73.018 5.218.018s4.975-.003 5.213-.015c.667-.032 1.054-.084 1.482-.194a4.12 4.12 0 0 0 2.69-2.202c.267-.551.402-1.088.463-1.866.014-.17.02-2.875.02-5.577s-.007-5.403-.02-5.573c-.062-.79-.198-1.323-.474-1.885a3.9 3.9 0 0 0-.843-1.155c-.652-.622-1.448-1.001-2.398-1.138-.46-.067-.552-.086-2.906-.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Instagram_svg__c)",
    d: "M16.006 6.152c-4.113 0-5.315.004-5.55.023-.843.07-1.368.203-1.94.488-.441.219-.789.473-1.132.829q-.937.972-1.141 2.395c-.067.46-.086.555-.09 2.907v3.201c0 4.11.005 5.31.024 5.544.068.821.197 1.338.47 1.903a4.15 4.15 0 0 0 2.69 2.197c.405.105.854.162 1.43.19.243.01 2.73.018 5.218.018s4.975-.003 5.213-.015c.667-.032 1.054-.084 1.482-.194a4.12 4.12 0 0 0 2.69-2.202c.267-.551.402-1.088.463-1.866.014-.17.02-2.875.02-5.577s-.007-5.403-.02-5.573c-.062-.79-.198-1.323-.474-1.885a3.9 3.9 0 0 0-.843-1.155c-.652-.622-1.448-1.001-2.398-1.138-.46-.067-.552-.086-2.906-.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 8.727c-1.975 0-2.223.009-2.999.044-.774.036-1.303.158-1.765.338a3.6 3.6 0 0 0-1.288.839 3.6 3.6 0 0 0-.84 1.288c-.18.462-.303.991-.338 1.765-.034.776-.043 1.024-.043 2.999s.008 2.222.043 2.998c.036.774.159 1.303.338 1.765.186.478.435.884.84 1.288.403.405.809.654 1.287.84.463.18.991.302 1.765.338.776.035 1.024.044 2.999.044s2.222-.009 2.998-.044c.774-.036 1.303-.158 1.766-.338a3.56 3.56 0 0 0 1.287-.84c.405-.404.653-.81.84-1.288.178-.462.301-.99.337-1.765.035-.776.044-1.023.044-2.998s-.009-2.223-.044-2.999c-.036-.774-.159-1.303-.337-1.765a3.6 3.6 0 0 0-.84-1.288 3.55 3.55 0 0 0-1.288-.839c-.463-.18-.992-.302-1.766-.338-.776-.035-1.023-.044-2.999-.044zm-.653 1.31H16c1.941 0 2.172.008 2.938.043.71.032 1.094.15 1.35.25.34.132.582.29.836.544.255.255.413.497.545.836.1.256.218.641.25 1.35.035.767.043.997.043 2.938s-.008 2.172-.043 2.938c-.032.71-.15 1.094-.25 1.35a2.25 2.25 0 0 1-.545.836 2.25 2.25 0 0 1-.835.544c-.256.1-.642.218-1.35.25-.767.035-.998.043-2.94.043s-2.171-.008-2.938-.043c-.71-.032-1.094-.151-1.35-.25a2.25 2.25 0 0 1-.837-.544 2.25 2.25 0 0 1-.544-.836c-.1-.257-.218-.641-.25-1.35-.035-.767-.042-.997-.042-2.94 0-1.942.007-2.17.042-2.937.032-.71.15-1.094.25-1.35.132-.34.29-.582.544-.837s.497-.412.837-.544c.256-.1.64-.218 1.35-.251.67-.03.93-.04 2.286-.04m4.535 1.208a.873.873 0 1 0 0 1.746.873.873 0 0 0 0-1.746M16 12.266a3.735 3.735 0 1 0 0 7.47 3.735 3.735 0 0 0 0-7.47m0 1.31a2.424 2.424 0 1 1 0 4.85 2.424 2.424 0 0 1 0-4.85"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Instagram_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 -19.5195 18.1591 0 11.385 27.364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Instagram_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.71299 8.55558 -35.27431 7.06259 2.852 7.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Instagram_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 6h20v20H6z"
  })))));
};
export default SvgInstagram;